import { Routes, RouterModule } from '@angular/router';

import { ProductCatalogComponent } from './ProductCatalog/ProductCatalog.component';
import { CatalogListComponent } from './catalog-list/catalog-list.component';
import { CatalogCardsComponent } from './catalog-cards/catalog-cards.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { IsAuthorized } from '@app/guards/IsAuthorized';

const routes: Routes = [

    { path: 'manage-catalog', component: ProductCatalogComponent, canActivate: [IsAuthorized]   }, 
    { path: 'manage-catalog/:id/:catalogCode', component: ProductCatalogComponent , canActivate: [IsAuthorized]  }, 
    { path: 'catalog-list', component: CatalogListComponent , canActivate: [IsAuthorized]  },
    { path: 'catalog-cards/:id/:catalogCode', component: CatalogCardsComponent },
    { path: 'product-details/:id/:catalogCode/:productId/:name', component: ProductDetailsComponent }

];

export const catalogProduct = RouterModule.forChild(routes);